import React from 'react';
import { WebSocketUrlOption } from '../types';

interface WebSocketSelectorProps {
  selectedUrl: WebSocketUrlOption;
  onUrlChange: (url: WebSocketUrlOption) => void;
}

const WebSocketSelector: React.FC<WebSocketSelectorProps> = ({ 
  selectedUrl, 
  onUrlChange 
}) => {
  const urls: { value: WebSocketUrlOption; label: string }[] = [
    { value: 'wss://ssr-dev.conworth.net/webrtc/server', label: 'wss://ssr-dev.conworth.net/webrtc/server' },
    { value: 'wss://ssr-staging.conworth.net/webrtc/server', label: 'wss://ssr-staging.conworth.net/webrtc/server' },
    { value: 'wss://ssr.conworth.net/webrtc/server', label: 'wss://ssr.conworth.net/webrtc/server' },
    { value: 'wss://ssr-gmep.conworth.net/webrtc/server', label: 'wss://ssr-gmep.conworth.net/webrtc/server' },
    { value: 'wss://ssr-aws.conworth.net/webrtc/server', label: 'wss://ssr-aws.conworth.net/webrtc/server' },
    { value: 'wss://ssr-azure.conworth.net/webrtc/server', label: 'wss://ssr-azure.conworth.net/webrtc/server' },
  ];

  return (
    <div className="websocket-selector">
      <label htmlFor="websocket-select" className="websocket-label">
        서버:
      </label>
      <select
        id="websocket-select"
        value={selectedUrl}
        onChange={(e) => onUrlChange(e.target.value as WebSocketUrlOption)}
        className="websocket-select"
      >
        {urls.map((url) => (
          <option key={url.value} value={url.value}>
            {url.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default WebSocketSelector;

